import {
  Anchor,
  Box,
  Button,
  Center,
  Divider,
  Group,
  HoverCard,
  SimpleGrid,
  ThemeIcon,
  UnstyledButton,
  rem,
  useMantineTheme,
  Text,
} from "@mantine/core";
import {useDisclosure} from "@mantine/hooks";
import {IconChevronDown} from "@tabler/icons-react";
import {link} from "fs";
import React from "react";

import classes from "./MobileButton.module.scss";

type MobileButtonProps = {
  link?: string | undefined;
  label: string;
  onClick?: Function | undefined;
};
export default function MobileButton({link, label, onClick}: MobileButtonProps) {
  return (
    <Button
      //ml={"auto"}
      key={label}
      variant="subtle"
      radius="xl"
      fw="500"
      size="sm"
      fs={".06rem"}
      color={"text"}
      onClick={onClick ? (e) => onClick?.() : undefined}
      renderRoot={link ? (props) => <a href={link} {...props} /> : undefined}
      className={classes.link}>
      {label}
    </Button>
  );
}
